import { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
  Menu,
  MenuItem,
} from "@mui/material";
import { delftBlue } from "@/theme/colors";
// import CategoryBadge from "./CategoryBadge";
import PDFIcon from "@/assets/hugeicons_pdf-01.svg";
import { useSelector } from "react-redux";
import { selectUser } from "@/app/features/auth/authSlice";
import Roles from "@/constants/roles";

const ViewIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7305 11.2265C19.9768 11.5715 20.0999 11.7449 20.0999 12C20.0999 12.256 19.9768 12.4285 19.7305 12.7736C18.6241 14.3255 15.798 17.67 11.9999 17.67C8.201 17.67 5.37572 14.3247 4.26926 12.7736C4.02302 12.4285 3.8999 12.2552 3.8999 12C3.8999 11.7441 4.02302 11.5715 4.26926 11.2265C5.37572 9.67451 8.20181 6.33002 11.9999 6.33002C15.7988 6.33002 18.6241 9.67532 19.7305 11.2265Z"
      stroke={delftBlue[500]}
      strokeWidth="1.215"
    />
    <path
      d="M14.4299 12C14.4299 11.3555 14.1739 10.7375 13.7182 10.2817C13.2625 9.82603 12.6444 9.57002 11.9999 9.57002C11.3554 9.57002 10.7373 9.82603 10.2816 10.2817C9.82592 10.7375 9.5699 11.3555 9.5699 12C9.5699 12.6445 9.82592 13.2626 10.2816 13.7183C10.7373 14.174 11.3554 14.43 11.9999 14.43C12.6444 14.43 13.2625 14.174 13.7182 13.7183C14.1739 13.2626 14.4299 12.6445 14.4299 12Z"
      stroke={delftBlue[500]}
      strokeWidth="1.215"
    />
  </svg>
);

const ViewIconSmall = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1537 7.48433C13.3179 7.71433 13.3999 7.82966 13.3999 8C13.3999 8.17067 13.3179 8.28567 13.1537 8.51567C12.4161 9.55033 10.532 11.78 7.99987 11.78C5.46733 11.78 3.58353 9.54966 2.8462 8.51567C2.682 8.28567 2.59987 8.17033 2.59987 8C2.59987 7.82933 2.682 7.71433 2.8462 7.48433C3.58353 6.44966 5.46733 4.22 7.99987 4.22C10.532 4.22 12.4161 6.44966 13.1537 7.48433Z"
      stroke={delftBlue[500]}
      strokeWidth="0.81"
    />
    <path
      d="M9.61987 8C9.61987 7.57033 9.4492 7.15833 9.14553 6.85466C8.84187 6.551 8.42987 6.38 7.99987 6.38C7.56987 6.38 7.15787 6.551 6.8542 6.85466C6.55053 7.15833 6.37987 7.57033 6.37987 8C6.37987 8.42967 6.55053 8.84167 6.8542 9.14533C7.15787 9.449 7.56987 9.62 7.99987 9.62C8.42987 9.62 8.84187 9.449 9.14553 9.14533C9.4492 8.84167 9.61987 8.42967 9.61987 8Z"
      stroke={delftBlue[500]}
      strokeWidth="0.81"
    />
  </svg>
);

const EditIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66667 2C8.83659 2.00019 9.00002 2.06525 9.12358 2.1819C9.24714 2.29855 9.32149 2.45797 9.33145 2.6276C9.34141 2.79722 9.28622 2.96425 9.17716 3.09455C9.0681 3.22486 8.9134 3.3086 8.74467 3.32867L8.66667 3.33333H3.33333V12.6667H12.6667V7.33333C12.6669 7.16341 12.7319 6.99998 12.8486 6.87642C12.9652 6.75286 13.1246 6.67851 13.2943 6.66855C13.4639 6.65859 13.6309 6.71378 13.7612 6.82284C13.8915 6.9319 13.9753 7.0866 13.9953 7.25533L14 7.33333V12.6667C14.0001 13.0031 13.8731 13.327 13.6443 13.5737C13.4156 13.8204 13.1021 13.9714 12.7667 13.9967L12.6667 14H3.33333C2.99695 14.0001 2.67296 13.8731 2.4263 13.6443C2.17965 13.4156 2.02856 13.1021 2.00333 12.7667L2 12.6667V3.33333C1.99989 2.99695 2.12694 2.67296 2.35566 2.4263C2.58439 2.17965 2.8979 2.02856 3.23333 2.00333L3.33333 2H8.66667ZM12.8287 2.22867C12.9486 2.1091 13.1096 2.03968 13.2789 2.03451C13.4482 2.02934 13.6131 2.08881 13.7402 2.20083C13.8672 2.31285 13.9469 2.46903 13.9629 2.63765C13.979 2.80626 13.9303 2.97467 13.8267 3.10867L13.7713 3.172L7.17133 9.77133C7.05136 9.8909 6.89038 9.96032 6.72108 9.96549C6.55178 9.97066 6.38686 9.91119 6.25981 9.79917C6.13277 9.68715 6.05313 9.53097 6.03707 9.36235C6.02101 9.19374 6.06973 9.02533 6.17333 8.89133L6.22867 8.82867L12.8287 2.22867Z"
      fill="black"
    />
  </svg>
);

const DeleteIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.1186 13.7647C4.79006 13.7647 4.51042 13.6493 4.27966 13.4185C4.04891 13.1878 3.93353 12.9084 3.93353 12.5803V3.49801H3.2002V2.76468H6.13353V2.20001H10.5335V2.76468H13.4669V3.49801H12.7335V12.5803C12.7335 12.9177 12.6206 13.1995 12.3947 13.4259C12.1689 13.6522 11.8868 13.7652 11.5485 13.7647H5.1186ZM12.0002 3.49801H4.66686V12.5803C4.66686 12.7119 4.70915 12.8199 4.79373 12.9045C4.87831 12.9891 4.9866 13.0313 5.1186 13.0313H11.5492C11.6616 13.0313 11.765 12.9844 11.8594 12.8905C11.9538 12.7967 12.0007 12.693 12.0002 12.5796V3.49801ZM6.72606 11.5647H7.45939V4.96468H6.72606V11.5647ZM9.20766 11.5647H9.941V4.96468H9.20766V11.5647Z"
      fill="#EA3929"
    />
  </svg>
);

const DocumentTable = ({
  documents = [],
  isLoading = false,
  onView,
  onEdit,
  onDelete,
}) => {
  const theme = useTheme();
  const user = useSelector(selectUser);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);

  // Check if current user is admin
  const isAdmin = user?.role === Roles.ADMIN;
  const isSuperAdmin = user?.role === Roles.SUPER_ADMIN;
  const S3_BASE_URL =
    "https://s3.ap-southeast-2.amazonaws.com/op-docx-bucket-prod";
  const CLOUDFRONT_URL = "https://d3hjliepkppdbb.cloudfront.net";
  // Transform API data to table structure
  const transformedDocuments = documents.map((doc) => ({
    id: doc._id || doc.id,
    _id: doc._id || doc.id,
    name: doc.title || doc.name || "Untitled Document",
    title: doc.title,
    activityName: doc.activityId?.name || doc.activityId?.code || "Others",
    fileType: doc.documentType || doc.fileType || "pdf",
    category: doc.category || "other",
    fileUrl: doc.fileUrl?.includes(S3_BASE_URL)
      ? doc.fileUrl.replace(S3_BASE_URL, CLOUDFRONT_URL)
      : doc.fileUrl.startsWith("http")
        ? doc.fileUrl
        : `${CLOUDFRONT_URL}${doc.fileUrl}`,
    originalName: doc.originalName,
    uploadedBy: doc.uploadedBy, // Include uploadedBy for permission checks
  }));

  const displayDocuments =
    transformedDocuments.length > 0 ? transformedDocuments : [];

  const handleMenuOpen = (event, document) => {
    setAnchorEl(event.currentTarget);
    setSelectedDocument(document);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedDocument(null);
  };

  const handleEditClick = (document) => {
    handleMenuClose();
    onEdit && onEdit(document);
  };

  const handleDeleteClick = (document) => {
    handleMenuClose();
    onDelete && onDelete(document);
  };

  // Helper to check if the currently logged-in admin uploaded this document
  const isOwnUpload = (document) => {
    if (!isAdmin || !document?.uploadedBy || !user?.email) return false;
    const uploadedEmail =
      typeof document.uploadedBy === "object"
        ? document.uploadedBy.email
        : null;
    if (!uploadedEmail) return false;
    return uploadedEmail.toLowerCase() === user.email.toLowerCase();
  };

  // Count available actions for a document
  const getAvailableActionCount = (document) => {
    let count = 0;
    if (onView) count++;
    if (onEdit && (isSuperAdmin || isOwnUpload(document))) count++;
    if (onDelete && (isSuperAdmin || isOwnUpload(document))) count++;
    return count;
  };

  const handleViewClick = (document) => {
    handleMenuClose();
    onView && onView(document);
  };

  return (
    <>
      <Box
        sx={{
          alignSelf: "stretch",
          position: "relative",
          overflowX: "auto",
          overflowY: "visible",
          borderRadius: 2,
          outline: `1px ${delftBlue[100]} solid`,
          outlineOffset: "-1px",
          width: "100%",
          "&::-webkit-scrollbar": {
            height: 8,
          },
          "&::-webkit-scrollbar-track": {
            background: delftBlue[50],
            borderRadius: 4,
          },
          "&::-webkit-scrollbar-thumb": {
            background: delftBlue[200],
            borderRadius: 4,
            "&:hover": {
              background: delftBlue[300],
            },
          },
        }}
      >
        <Table
          sx={{
            minWidth: { xs: 600, sm: "100%" },
            width: "100%",
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: delftBlue[500],
                "& .MuiTableCell-root": {
                  backgroundColor: `${delftBlue[500]} !important`,
                },
              }}
            >
              <TableCell
                sx={{
                  flex: "1 1 0",
                  height: { xs: 44, sm: 48 },
                  paddingLeft: { xs: 1.5, sm: 2 },
                  paddingRight: { xs: 1.5, sm: 2 },
                  paddingTop: { xs: 0.75, sm: 1 },
                  paddingBottom: { xs: 0.75, sm: 1 },
                  backgroundColor: `${delftBlue[500]} !important`,
                  borderRight: `1px ${theme.palette.neutral[200]} solid`,
                  borderBottom: `1px ${theme.palette.neutral[200]} solid`,
                  minWidth: { xs: 150, sm: "auto" },
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: { xs: 12, sm: 13 },
                    fontFamily: "Audiowide, sans-serif",
                    fontWeight: 400,
                  }}
                >
                  Documents
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  flex: "1 1 0",
                  height: { xs: 44, sm: 48 },
                  paddingLeft: { xs: 1.5, sm: 2 },
                  paddingRight: { xs: 1.5, sm: 2 },
                  paddingTop: { xs: 0.75, sm: 1 },
                  paddingBottom: { xs: 0.75, sm: 1 },
                  backgroundColor: `${delftBlue[500]} !important`,
                  borderRight: `1px ${theme.palette.neutral[200]} solid`,
                  borderBottom: `1px ${theme.palette.neutral[200]} solid`,
                  minWidth: { xs: 150, sm: "auto" },
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: { xs: 12, sm: 13 },
                    fontFamily: "Audiowide, sans-serif",
                    fontWeight: 400,
                  }}
                >
                  Activity Name
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: { xs: 100, sm: 128 },
                  height: { xs: 44, sm: 48 },
                  paddingLeft: { xs: 1.5, sm: 2 },
                  paddingRight: { xs: 1.5, sm: 2 },
                  paddingTop: { xs: 0.75, sm: 1 },
                  paddingBottom: { xs: 0.75, sm: 1 },
                  backgroundColor: `${delftBlue[500]} !important`,
                  borderRight: `1px ${theme.palette.neutral[200]} solid`,
                  borderBottom: `1px ${theme.palette.neutral[200]} solid`,
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: { xs: 12, sm: 13 },
                    fontFamily: "Audiowide, sans-serif",
                    fontWeight: 400,
                  }}
                >
                  File Type
                </Typography>
              </TableCell>
              {/* <TableCell
                sx={{
                  width: { xs: 120, sm: 160 },
                  height: { xs: 44, sm: 48 },
                  paddingLeft: { xs: 1.5, sm: 2 },
                  paddingRight: { xs: 1.5, sm: 2 },
                  paddingTop: { xs: 0.75, sm: 1 },
                  paddingBottom: { xs: 0.75, sm: 1 },
                  backgroundColor: `${delftBlue[500]} !important`,
                  borderRight: `1px ${theme.palette.neutral[200]} solid`,
                  borderBottom: `1px ${theme.palette.neutral[200]} solid`,
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: { xs: 12, sm: 13 },
                    fontFamily: "Audiowide, sans-serif",
                    fontWeight: 400,
                  }}
                >
                  Category
                </Typography>
              </TableCell> */}
              <TableCell
                sx={{
                  height: { xs: 44, sm: 48 },
                  paddingLeft: { xs: 1.5, sm: 2 },
                  paddingRight: { xs: 1.5, sm: 2 },
                  paddingTop: { xs: 0.75, sm: 1 },
                  paddingBottom: { xs: 0.75, sm: 1 },
                  backgroundColor: `${delftBlue[500]} !important`,
                  textAlign: { xs: "left", sm: "center" },
                  minWidth: { xs: 100, sm: "auto" },
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: 13,
                    fontFamily: "Audiowide, sans-serif",
                    fontWeight: 400,
                  }}
                >
                  Actions
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                  <Typography>Loading documents...</Typography>
                </TableCell>
              </TableRow>
            ) : displayDocuments.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                  <Typography>No documents found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              displayDocuments.map((document, index) => (
                <TableRow
                  key={document.id || index}
                  sx={{
                    height: { xs: 50, sm: 40 },
                    background: index % 2 === 0 ? "white" : delftBlue[50],
                    borderBottom: `1px ${theme.palette.neutral[200]} solid`,
                    "&:hover": {
                      background: theme.palette.neutral[50],
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      flex: "1 1 0",
                      paddingLeft: { xs: 1.5, sm: 2 },
                      paddingRight: { xs: 1.5, sm: 2 },
                      borderRight: `1px ${theme.palette.neutral[200]} solid`,
                    }}
                  >
                    <Typography
                      sx={{
                        color: theme.palette.neutral[700],
                        fontSize: { xs: 14, sm: 15, md: 16 },
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: 500,
                        wordBreak: "break-word",
                      }}
                    >
                      {document.name}
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      flex: "1 1 0",
                      paddingLeft: { xs: 1.5, sm: 2 },
                      paddingRight: { xs: 1.5, sm: 2 },
                      borderRight: `1px ${theme.palette.neutral[200]} solid`,
                    }}
                  >
                    <Typography
                      sx={{
                        color: theme.palette.neutral[700],
                        fontSize: { xs: 14, sm: 15, md: 16 },
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: 500,
                        wordBreak: "break-word",
                      }}
                    >
                      {document.activityName}
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      width: { xs: 100, sm: 128 },
                      paddingLeft: { xs: 1.5, sm: 2 },
                      paddingRight: { xs: 1.5, sm: 2 },
                      borderRight: `1px ${theme.palette.neutral[200]} solid`,
                      textAlign: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={PDFIcon}
                      alt="PDF"
                      sx={{
                        width: { xs: 20, sm: 24 },
                        height: { xs: 20, sm: 24 },
                        objectFit: "contain",
                      }}
                    />
                  </TableCell>
                  {/* <TableCell
                  sx={{
                    width: { xs: 120, sm: 160 },
                    paddingLeft: { xs: 1.5, sm: 2 },
                    paddingRight: { xs: 1.5, sm: 2 },
                    borderRight: `1px ${theme.palette.neutral[200]} solid`,
                  }}
                >
                  <CategoryBadge category={document.category} />
                </TableCell> */}
                  <TableCell
                    sx={{
                      paddingLeft: { xs: 1.5, sm: 2 },
                      paddingRight: { xs: 1.5, sm: 2 },
                      textAlign: { xs: "left", sm: "right" },
                    }}
                  >
                    <Box
                      onClick={(e) => {
                        const actionCount = getAvailableActionCount(document);
                        if (actionCount === 1 && onView) {
                          // Only View is available, open directly
                          handleViewClick(document);
                        } else {
                          // Multiple actions available, show menu
                          handleMenuOpen(e, document);
                        }
                      }}
                      sx={{
                        paddingLeft: { xs: 0.75, sm: 1 },
                        paddingRight: { xs: 0.75, sm: 1 },
                        paddingTop: { xs: 0.5, sm: 0.5 },
                        paddingBottom: { xs: 0.5, sm: 0.5 },
                        background: "white",
                        borderRadius: 2,
                        outline: `1px ${theme.palette.neutral[200]} solid`,
                        outlineOffset: "-1px",
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                        touchAction: "manipulation",
                        minWidth: { xs: 60, sm: "auto" },
                        "&:hover": {
                          background: theme.palette.neutral[50],
                        },
                        "&:active": {
                          background: theme.palette.neutral[100],
                        },
                      }}
                    >
                      <ViewIcon />
                      <Typography
                        sx={{
                          color: delftBlue[500],
                          fontSize: { xs: 12, sm: 13 },
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        View
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Box>

      {/* Action Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            width: 128,
            padding: 1,
            background: "white",
            boxShadow: "0px 2px 4px -2px rgba(0, 0, 0, 0.10)",
            borderRadius: 1.5,
            display: "flex",
            flexDirection: "column",
            gap: 0,
          },
        }}
      >
        {onView && (
          <MenuItem
            onClick={() => {
              handleMenuClose();
              onView(selectedDocument);
            }}
            sx={{
              padding: 0.5,
              borderRadius: 0.5,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 0.5,
              "&:hover": {
                background: theme.palette.neutral[50],
              },
            }}
          >
            <ViewIconSmall />
            <Typography
              sx={{
                color: theme.palette.neutral[900],
                fontSize: 13,
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
                lineHeight: 1.54,
              }}
            >
              View
            </Typography>
          </MenuItem>
        )}
        {onEdit &&
          (isSuperAdmin ||
            (selectedDocument && isOwnUpload(selectedDocument))) && (
            <MenuItem
              onClick={() => handleEditClick(selectedDocument)}
              sx={{
                padding: 0.5,
                borderRadius: 0.5,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 0.5,
                "&:hover": {
                  background: theme.palette.neutral[50],
                },
              }}
            >
              <EditIcon />
              <Typography
                sx={{
                  color: theme.palette.neutral[900],
                  fontSize: 13,
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 500,
                  lineHeight: 1.54,
                }}
              >
                Edit
              </Typography>
            </MenuItem>
          )}
        {onDelete &&
          (isSuperAdmin ||
            (selectedDocument && isOwnUpload(selectedDocument))) && (
            <MenuItem
              onClick={() => handleDeleteClick(selectedDocument)}
              sx={{
                padding: 0.5,
                borderRadius: 0.5,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 0.5,
                "&:hover": {
                  background: theme.palette.neutral[50],
                },
              }}
            >
              <DeleteIcon />
              <Typography
                sx={{
                  color: theme.palette.error.main,
                  fontSize: 13,
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 500,
                  lineHeight: 1.54,
                }}
              >
                Delete
              </Typography>
            </MenuItem>
          )}
      </Menu>
    </>
  );
};

export default DocumentTable;
